<template>
  <div
    ref="chipEl"
    class="bg-static-default-low rounded-full caption flex w-fit items-center overflow-hidden p-4 pr-8 text-center md:body-2"
  >
    <div ref="iconEl" class="h-16 w-16 shrink-0">
      <DynamicIcon :icon="displayedIcon as IconName" />
    </div>
    <div ref="labelEl" class="ml-4 whitespace-nowrap text-left">
      {{ displayedText }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef, watch } from 'vue'

import type { IconName } from '@backmarket/design-system/icons/icons'
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'

import type { ChipTag } from '../../ConditionGuidance.types'
import { useChipSwapAnimation } from '../../composables/useChipAnimations'

const props = defineProps<{
  tag: ChipTag
  index: number
}>()

const chipEl = useTemplateRef('chipEl')
const iconEl = useTemplateRef('iconEl')
const labelEl = useTemplateRef('labelEl')

const displayedIcon = ref(props.tag.icon)
const displayedText = ref(props.tag.text)

const { animateSwap } = useChipSwapAnimation(chipEl, iconEl, labelEl)

watch(
  () => props.tag,
  (newTag, oldTag) => {
    animateSwap(
      newTag,
      oldTag,
      props.index,
      (icon) => {
        displayedIcon.value = icon
      },
      (text) => {
        displayedText.value = text
      },
    )
  },
  { deep: true },
)
</script>
